//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UserSidebar from './UserSidebar.vue';

export default {
  name: 'UserActionsPage',
  components: {
    UserSidebar,
  },
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    this.show = true; // delay 'show' to fade component in.
  },
};
